<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex"
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Creditors",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Credit Purchases",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Creditors",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "supplier",
          sortable: true,
          label: "SUPPLIER",
        },
        {
          key: "details",
          sortable: true,
          label: "PRODUCTS",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "actions",
          sortable: false,
          label: "ACTION",
        },
      ],
      clear: {
        id: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        paid: "",
        mode: "",
        totals: "",
      },
      totals: {
        totalAmount: 0,
        totalPaid: 0,
        totalDiscount: 0,
      },
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        supplier: "",
        period: 0,
        branch_id: 0
      },
      amountError: "",
      modeError: "",

    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("purchase", ["SaveStatus", "Creditors", "PurchaseId", "FilterStatus"]),
    ...mapGetters("setting", ["PaymentOptions", "ReceiptSettings"]),
    ...mapGetters("auth", ["MyUserPerm", "Branches", "branchid"]),
    ...mapGetters("stock", ["Suppliers"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Creditors ? this.Creditors.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Creditors ? this.Creditors.length : 1;
  },
  updated() {

  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },

    PurchaseId(newValue) {
      if (newValue && this.ReceiptSettings.print_receipt_after_purchase == 1) {
        window.open(
          `https://${window.location.host}/receipts/creditorsreceipt.php?id=${btoa(newValue)}`
        );
      }
    },
    Creditors(newValue) {
      if (newValue) {
        this.CreditorsData();
      }
    },
  },
  methods: {
    ...mapActions({
      FetchCreditors: "purchase/fetchCreditors",
      ClearBalance: "purchase/ClearCredit",
      ClearBalancePrint: "purchase/ClearCreditPrint",
      FetchModes: "setting/fetchPaymentOptions",
      FetchReceiptSettings: "setting/fetchReceiptSettings",
      FetchSuppliers: "stock/fetchSuppliers",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    setDefaultMode() {
      let defaultop = this.PaymentOptions ? this.PaymentOptions : [].filter((mode) => {
        return mode.default == 1;
      })
      this.clear.mode = defaultop[0] ? defaultop[0].id : 0;
    },
    resetModal() {
      this.clear.id = "";
      this.clear.paid = "";
      this.setDefaultMode();
      this.clear.total = "";
    },
    resetError() {
      this.amountError = "";
      this.modeError = "";
    },
    addCommas() {
      this.clear.paid = this.thousandSeperator(this.clear.paid);
    },
    ShowClear(data) {
      this.clear.id = data.id;
      this.clear.paid = (data.totAmt - data.amtPaid - data.discount).toLocaleString();
      this.clear.total = data.totAmt;
    },
    checkAmt() {
      if (this.clear.paid.replace(/,/g, '') > this.clear.total) {
        this.amountError = "Amount Paid is greater than balance";
        return
      }
      else {
        this.amountError = "";
      }
    },
    clearAmt(modalId) {
      this.modal_id = modalId;
      if (this.clear.paid == "") {
        this.amountError = "Amount Paid is required";
        return
      }
      else {
        this.amountError = "";
      }
      if (this.clear.paid.replace(/,/g, '') > this.clear.total) {
        this.amountError = "Amount Paid is greater than balance";
        return
      }
      else {
        this.amountError = "";
      }
      if (this.clear.mode == "") {
        this.modeError = "Payment Method is required";
        return
      }
      else {
        this.modeError = "";
      }
      this.ClearBalance(this.clear);
    },

    clearAmtPrint(modalId) {
      this.modal_id = modalId;
      if (this.clear.paid == "") {
        this.amountError = "Amount Paid is required";
        return
      }
      else {
        this.amountError = "";
      }
      if (this.clear.paid.replace(/,/g, '') > this.clear.total) {
        this.amountError = "Amount Paid is greater than balance";
        return
      }
      else {
        this.amountError = "";
      }
      if (this.clear.mode == "") {
        this.modeError = "Payment Method is required";
        return
      }
      else {
        this.modeError = "";
      }
      this.ClearBalancePrint(this.clear);
      this.closeModal(modalId);
    },
    closeModal(modalId) {
      this.resetError();
      this.resetModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    filterReport() {
      this.FetchCreditors(this.data);
    },

    CreditorsData() {
      this.filteredReport = this.Creditors;
      let total_amount = 0;
      let total_paid = 0;
      let total_discount = 0;
      this.Creditors.forEach((item) => {
        total_amount = total_amount + parseInt(item.totAmt);
        total_paid = total_paid + parseInt(item.amtPaid);
        total_discount = total_discount + parseInt(item.discount);

        this.totals.totalBalance = this.totals.totalAmount - (this.totals.totalPaid + this.totals.totalDiscount);
      });
      this.totals.totalPaid = total_paid;
      this.totals.totalAmount = total_amount;
      this.totals.totalDiscount = total_discount;
      this.totals.totalBalance = total_amount - (total_paid + total_discount)
    },

    Excel_export() {
      axios
        .post("export_creditors", this.data, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "creditors_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {
        });
    },

  },
  created() {
    this.FetchModes();
    this.FetchSuppliers();
    this.FetchCreditors(this.data);
    this.CreditorsData();
    setTimeout(() => {
      this.setDefaultMode();
    }, 3000);
    this.FetchReceiptSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-8">
                <h4 class="card-title">Items Bought On Credit</h4>
              </div>
              <div class="col-md-4 mb-3" v-if="branchid == 0">
                <label>FILTER BY BRANCHES</label>
                <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []" v-model="data.branch_id" option-value="id"
                  option-text="name" placeholder="Select Branch" @input="filterReport()">
                </model-list-select>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-8" align="right">
                <router-link to="/purchases/imported_creditors"><b-button variant="info">Imported
                    Creditors</b-button></router-link>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>From</label>
                  <input type="date" v-model="data.datefrom" class="form-control" />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>To</label>
                  <input type="date" v-model="data.dateto" class="form-control" />
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label>Supplier</label>

                <model-list-select :list="Suppliers ? Suppliers : []" v-model="data.supplier" option-value="id"
                  option-text="name" placeholder="Select Supplier" @input="filterReport()">
                </model-list-select>
              </div>
              <div class="col-md-2 form-group">
                <label>Period</label>
                <select class="form-control" v-model="data.period" @input="filterReport()">
                  <option value="0" selected>Selected</option>
                  <option value="1" selected>All time</option>
                </select>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="FilterStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table class="datatables" :items="Creditors ? Creditors : []" :fields="fields" responsive="sm"
                :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(tt_amt)="data">
                  {{ (data.item.totAmt) ? (data.item.totAmt).toLocaleString() : 0 }}
                </template>
                <template #cell(amt_paid)="data">
                  {{ (data.item.amtPaid) ? (data.item.amtPaid).toLocaleString() : 0 }}
                </template>
                <template #cell(discount_field)="data">
                  {{ (data.item.discount) ? (data.item.discount).toLocaleString() : 0 }}
                </template>
                <template #cell(balance)="data">
                  {{ (data.item.Balance) ? (data.item.Balance).toLocaleString() : 0 }}
                </template>
                <template v-if="MyUserPerm.clear_creditors == 1 && branchid != 0" #cell(actions)="data">
                  <button @click="ShowClear(data.item)" class="btn btn-primary btn-sm" v-b-modal.clear-modal><i
                      class="fa fa-check"></i> Clear</button>
                </template>
                <template #cell(details)="data">
                  <table class="table">
                    <tbody>
                      <tr v-for="(det, d) in data.item.items" :key="d" width="100%">
                        <td>{{ det.product }}</td>
                        <td>{{ det.qty }}{{ det.usymbol }}</td>
                      </tr>
                    </tbody>
                  </table>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col-md-3">
                <h5>Total Amount: <span class="text-danger">{{ thousandSeperator(totals.totalAmount) }}</span></h5>
              </div>
              <div class="col-md-3">
                <h5>Total Paid: <span class="text-danger">{{ thousandSeperator(totals.totalPaid) }}</span></h5>
              </div>
              <div class="col-md-3">
                <h5>Total Discount: <span class="text-danger">{{ thousandSeperator(totals.totalDiscount) }}</span></h5>
              </div>
              <div class="col-md-3">
                <h5>Total Balance: <span
                    class="text-danger">{{ thousandSeperator(totals.totalAmount - (totals.totalPaid + totals.totalDiscount)) }}</span>
                </h5>
              </div>
            </div>
            <Loader v-if="!Creditors" />
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal mark as expired starts -->
    <b-modal id="clear-modal" hide-footer @hidden="resetModal()">
      <template #modal-title>
        <h4 class="text-warning">Clear Credit of {{ thousandSeperator(clear.paid) }}</h4>
      </template>
      <label>Amount Paid</label>
      <div class="input-group">
        <input type="text" class="form-control" v-model="clear.paid" placeholder="Quantity removed"
          @input="resetError(), addCommas(), checkAmt()" />
      </div>
      <div class="text-danger" v-if="amountError">
        <em>{{ amountError }}</em>
      </div>
      <div class="form-group">
        <label>Payment Method <span class="text-danger">*</span></label>
        <model-list-select :list="PaymentOptions ? PaymentOptions : []" v-model="clear.mode" option-value="id"
          option-text="mode" placeholder="Select Method" @input="resetError()">
        </model-list-select>
      </div>
      <div class="text-danger" v-if="modeError">
        <em>{{ modeError }}</em>
      </div>
      <label>Payment Date</label>
      <div class="input-group">
        <input type="date" class="form-control" v-model="clear.date" />
      </div>
      <div class="row mt-3">
        <div class="col-md-4">
          <button v-if="SaveStatus" type="button" class="btn btn-warning" disabled>
            <i class="fa fa-minus"></i> Confirm & Exit
            <b-spinner variant="light" small label="Submiting"></b-spinner>
          </button>
          <button v-else type="button" class="btn btn-warning" @click="clearAmt('clear-modal')">
            <i class="fa fa-minus"></i> Confirm & Exit
          </button>
        </div>
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <button v-if="SaveStatus" type="button" class="btn btn-warning" disabled>
            <i class="fa fa-minus"></i> Confirm & Print
            <b-spinner variant="light" small label="Submiting"></b-spinner>
          </button>
          <button v-else type="button" class="btn btn-warning" @click="clearAmtPrint('clear-modal')">
            <i class="fa fa-minus"></i> Confirm & Print
          </button>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>
